module.exports = __webpack_public_path__ + "img/fsg_baseball.7f28346f.svg";